import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.163 8.409c2.696.423 5.324-1.262 6.043-3.966l-1.45-.386c-.559 2.103-2.7 3.342-4.776 2.781l-.559-.15-4.38 7.644c-.287.5-.69.921-1.173 1.228m6.295-7.151l-3.821 6.67a5.03 5.03 0 01-1.671 1.748c-.315.2-.16.673.188.673h1.518c.784 0 1.557-.208 2.237-.604l7.865-4.574a2.069 2.069 0 00.746-2.813l-1.51-2.637 1.301-.746 1.51 2.636a3.57 3.57 0 01-1.293 4.857l-7.865 4.574A5.954 5.954 0 017.377 19H5.859c-1.874 0-2.555-2.45-.991-3.44",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.978-.026.504.104.966.414 1.131.56.298 1.132-.32 1.467-.762L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.975c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.7.143 1.34.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.7-4.777 4.743c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.742 6.828a7.008 7.008 0 008.015-5.082l-1.449-.389a5.508 5.508 0 01-6.746 3.894l-.556-.149L4.212 15.14a4.99 4.99 0 01-1.663 1.728C.648 18.064 1.496 21 3.742 21h2.042c1.365 0 2.709-.36 3.892-1.043l10.58-6.109a4.5 4.5 0 001.647-6.146L19.871 4.18l-1.299.75 2.032 3.52a3 3 0 01-1.097 4.098L8.926 18.66a6.288 6.288 0 01-3.142.84H3.742c-.743 0-1.02-.967-.394-1.361a6.49 6.49 0 002.163-2.247l5.23-9.063z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.484 13.656c7.105 1.292 14.127-3.067 16.03-10.164l-2.897-.777c-1.576 5.876-7.615 9.363-13.493 7.788l-1.112-.298L8.425 30.28a9.98 9.98 0 01-3.326 3.455C1.296 36.128 2.992 42 7.483 42h4.084c2.732 0 5.418-.72 7.784-2.085l21.162-12.218c4.303-2.486 5.78-7.99 3.294-12.293l-4.064-7.042-2.599 1.5 4.064 7.041a6 6 0 01-2.195 8.196L17.852 37.316A12.577 12.577 0 0111.567 39H7.483c-1.484 0-2.04-1.937-.787-2.725a12.98 12.98 0 004.326-4.493l10.462-18.126z",
    clipRule: "evenodd"
  }))
};
export var Shoe = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});